import { render, staticRenderFns } from "./CashFlux.vue?vue&type=template&id=8d3ccb6c&scoped=true&"
import script from "./CashFlux.vue?vue&type=script&lang=js&"
export * from "./CashFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3ccb6c",
  null
  
)

export default component.exports